import { useState } from 'react'

import Widget from 'common/components/Widget'
import { formatDate } from 'common/helpers/date'
import { useAppSelector } from 'common/hooks/redux'

import EmojiPerformanceWidget from '../emojiPerformance/EmojiPerformanceWidget'
import SummaryWidgetContainer from '../SummaryWidget/SummaryWidgetContainer'
import WordPerformanceWidget from '../wordPerformance/WordPerformanceWidget'

type Props = {
  projectId: string | undefined
  startDate: string
  endDate: string
}
const FirstWidgets = ({ projectId, startDate, endDate }: Props) => {
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const [hasWordData, setHasWordData] = useState(true)

  const projectIds = projectId ? [projectId] : []
  return (
    <Widget direction="column">
      <div className="flex flex-col gap-6 ">
        <div className="text-xl text-coolGray-800 font-medium">
          {`${formatDate(startDate)} - ${formatDate(endDate)}`}
        </div>
        <SummaryWidgetContainer
          project={projectId!}
          startDate={startDate}
          endDate={endDate}
          mode="projectComparison"
        />
      </div>
      {hasWordData && (
        <WordPerformanceWidget
          accountId={accountId}
          projectIds={projectIds}
          startDate={startDate}
          endDate={endDate}
          setHasData={setHasWordData}
        />
      )}
      <EmojiPerformanceWidget
        accountId={accountId}
        projectIds={projectIds}
        startDate={startDate}
        endDate={endDate}
      />
    </Widget>
  )
}

export default FirstWidgets
